import {
    createContext,
    useContext,
    useState,
    ReactNode,
    SetStateAction,
    Dispatch,
  } from "react";
  
  import { ICourseRegistration } from "../EnrollTypes";
  
  
  type EnrolleeContextType = {
    Enrollee: ICourseRegistration[] | null;
    setEnrolleeContext: Dispatch<SetStateAction<ICourseRegistration[] | null>>;
  };
  
  const EnrolleeContext = createContext<EnrolleeContextType | undefined>(undefined);
  
  export const EnrolleeProvider: React.FC<{ children: ReactNode }> = ({
    children,
  }) => {
    const [Enrollee, setEnrolleeContext] = useState<ICourseRegistration[] | null>(null);
    return (
      <EnrolleeContext.Provider
        value={{ Enrollee, setEnrolleeContext }}
      >
        {children}
      </EnrolleeContext.Provider>
    );
  };
  
  export const useEnrollee = () => {
    const context = useContext(EnrolleeContext);
    if (!context) {
      throw new Error("useEnrollee must be used within a EnrolleeProvider");
    }
    return context;
  };
  
  
  